import { cn } from "@/lib/utils"
import { CircleHelp, type LucideProps } from "lucide-react"
import { iconRegistry, type IconName } from "@/components/ui/icon-registry"

export type { IconName } from "@/components/ui/icon-registry"

export interface IconProps extends Omit<LucideProps, "ref" | "name"> {
  name: string
  filled?: boolean
}

/**
 * Ícone padronizado — substitui `material-symbols-outlined`.
 * Aceita nomes legados do Material Symbols via registry.
 */
export function Icon({ name, className, filled, ...props }: IconProps) {
  const LucideIcon = iconRegistry[name as IconName]

  if (!LucideIcon) {
    if (import.meta.env.DEV) {
      console.warn(`[Icon] unknown name: ${name}`)
    }
    return (
      <CircleHelp
        aria-hidden
        className={cn("inline-block size-[1em] shrink-0", className)}
        {...props}
      />
    )
  }

  const isSpinner = name === "progress_activity"

  return (
    <LucideIcon
      aria-hidden
      className={cn(
        "inline-block size-[1em] shrink-0",
        isSpinner && "animate-spin",
        filled && "fill-current",
        className)}
      {...props}
    />
  )
}
